export default __webpack_public_path__ + "static/media/aryze-mountain.99ba0b02.jpg";